/**
 * Generated by orval v8.12.3 🍺
 * Do not edit manually.
 * TorqueTitan API
 * Auto repair shop management API
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  ApiError,
  CurrentUserNullable,
  SetCurrentShopBody,
  UpdateProfile,
  UploadAvatarBody,
  UploadAvatarResponse,
} from './torqueTitanAPI.schemas';

import { apiFetcher } from '../apiFetcher';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export const getGetCurrentUserUrl = () => {
  return `/current-user`;
};

/**
 * Returns the authenticated user profile with their roles, shops, and preferences
 * @summary Get current user
 */
export const getCurrentUser = async (options?: RequestInit): Promise<CurrentUserNullable> => {
  return apiFetcher<CurrentUserNullable>(getGetCurrentUserUrl(), {
    ...options,
    method: 'GET',
  });
};

export const getGetCurrentUserQueryKey = () => {
  return [`/current-user`] as const;
};

export const getGetCurrentUserQueryOptions = <
  TData = Awaited<ReturnType<typeof getCurrentUser>>,
  TError = ApiError,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentUser>>, TError, TData>>;
  request?: SecondParameter<typeof apiFetcher>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCurrentUserQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCurrentUser>>> = ({ signal }) =>
    getCurrentUser({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCurrentUser>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCurrentUserQueryResult = NonNullable<Awaited<ReturnType<typeof getCurrentUser>>>;
export type GetCurrentUserQueryError = ApiError;

export function useGetCurrentUser<TData = Awaited<ReturnType<typeof getCurrentUser>>, TError = ApiError>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentUser>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCurrentUser>>,
          TError,
          Awaited<ReturnType<typeof getCurrentUser>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetCurrentUser<TData = Awaited<ReturnType<typeof getCurrentUser>>, TError = ApiError>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentUser>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCurrentUser>>,
          TError,
          Awaited<ReturnType<typeof getCurrentUser>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetCurrentUser<TData = Awaited<ReturnType<typeof getCurrentUser>>, TError = ApiError>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentUser>>, TError, TData>>;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get current user
 */

export function useGetCurrentUser<TData = Awaited<ReturnType<typeof getCurrentUser>>, TError = ApiError>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentUser>>, TError, TData>>;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetCurrentUserQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getUpdateCurrentUserUrl = () => {
  return `/current-user`;
};

/**
 * Updates the authenticated user profile fields
 * @summary Update current user profile
 */
export const updateCurrentUser = async (updateProfile?: UpdateProfile, options?: RequestInit): Promise<void> => {
  return apiFetcher<void>(getUpdateCurrentUserUrl(), {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateProfile),
  });
};

export const getUpdateCurrentUserMutationOptions = <TError = ApiError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCurrentUser>>,
    TError,
    { data?: UpdateProfile },
    TContext
  >;
  request?: SecondParameter<typeof apiFetcher>;
}): UseMutationOptions<Awaited<ReturnType<typeof updateCurrentUser>>, TError, { data?: UpdateProfile }, TContext> => {
  const mutationKey = ['updateCurrentUser'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCurrentUser>>, { data?: UpdateProfile }> = (
    props
  ) => {
    const { data } = props ?? {};

    return updateCurrentUser(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateCurrentUserMutationResult = NonNullable<Awaited<ReturnType<typeof updateCurrentUser>>>;
export type UpdateCurrentUserMutationBody = UpdateProfile | undefined;
export type UpdateCurrentUserMutationError = ApiError;

/**
 * @summary Update current user profile
 */
export const useUpdateCurrentUser = <TError = ApiError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateCurrentUser>>,
      TError,
      { data?: UpdateProfile },
      TContext
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof updateCurrentUser>>, TError, { data?: UpdateProfile }, TContext> => {
  return useMutation(getUpdateCurrentUserMutationOptions(options), queryClient);
};
export const getUploadAvatarUrl = () => {
  return `/current-user/upload-avatar`;
};

/**
 * Uploads a new avatar image for the current user. Accepts multipart/form-data with a file field.
 * @summary Upload user avatar
 */
export const uploadAvatar = async (
  uploadAvatarBody?: UploadAvatarBody,
  options?: RequestInit
): Promise<UploadAvatarResponse> => {
  const formData = new FormData();
  if (uploadAvatarBody?.file !== undefined) {
    formData.append(`file`, uploadAvatarBody.file);
  }

  return apiFetcher<UploadAvatarResponse>(getUploadAvatarUrl(), {
    ...options,
    method: 'POST',
    body: formData,
  });
};

export const getUploadAvatarMutationOptions = <TError = ApiError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uploadAvatar>>,
    TError,
    { data?: UploadAvatarBody },
    TContext
  >;
  request?: SecondParameter<typeof apiFetcher>;
}): UseMutationOptions<Awaited<ReturnType<typeof uploadAvatar>>, TError, { data?: UploadAvatarBody }, TContext> => {
  const mutationKey = ['uploadAvatar'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadAvatar>>, { data?: UploadAvatarBody }> = (
    props
  ) => {
    const { data } = props ?? {};

    return uploadAvatar(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UploadAvatarMutationResult = NonNullable<Awaited<ReturnType<typeof uploadAvatar>>>;
export type UploadAvatarMutationBody = UploadAvatarBody | undefined;
export type UploadAvatarMutationError = ApiError;

/**
 * @summary Upload user avatar
 */
export const useUploadAvatar = <TError = ApiError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof uploadAvatar>>,
      TError,
      { data?: UploadAvatarBody },
      TContext
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof uploadAvatar>>, TError, { data?: UploadAvatarBody }, TContext> => {
  return useMutation(getUploadAvatarMutationOptions(options), queryClient);
};
export const getDismissOnboardingUrl = () => {
  return `/current-user/onboarding/dismiss`;
};

/**
 * Dismisses the onboarding prompt for the current user without completing it
 * @summary Dismiss onboarding
 */
export const dismissOnboarding = async (options?: RequestInit): Promise<void> => {
  return apiFetcher<void>(getDismissOnboardingUrl(), {
    ...options,
    method: 'POST',
  });
};

export const getDismissOnboardingMutationOptions = <TError = ApiError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof dismissOnboarding>>, TError, void, TContext>;
  request?: SecondParameter<typeof apiFetcher>;
}): UseMutationOptions<Awaited<ReturnType<typeof dismissOnboarding>>, TError, void, TContext> => {
  const mutationKey = ['dismissOnboarding'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof dismissOnboarding>>, void> = () => {
    return dismissOnboarding(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DismissOnboardingMutationResult = NonNullable<Awaited<ReturnType<typeof dismissOnboarding>>>;

export type DismissOnboardingMutationError = ApiError;

/**
 * @summary Dismiss onboarding
 */
export const useDismissOnboarding = <TError = ApiError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<typeof dismissOnboarding>>, TError, void, TContext>;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof dismissOnboarding>>, TError, void, TContext> => {
  return useMutation(getDismissOnboardingMutationOptions(options), queryClient);
};
export const getDismissSetupAnnouncementUrl = () => {
  return `/current-user/setup-announcement/dismiss`;
};

/**
 * Sets profiles.setup_announcement_show_until to a past timestamp so the soft 'we've simplified onboarding' dashboard banner stops rendering. Idempotent — re-POSTing is a no-op equivalent.
 * @summary Dismiss the soft setup announcement banner
 */
export const dismissSetupAnnouncement = async (options?: RequestInit): Promise<void> => {
  return apiFetcher<void>(getDismissSetupAnnouncementUrl(), {
    ...options,
    method: 'POST',
  });
};

export const getDismissSetupAnnouncementMutationOptions = <TError = ApiError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof dismissSetupAnnouncement>>, TError, void, TContext>;
  request?: SecondParameter<typeof apiFetcher>;
}): UseMutationOptions<Awaited<ReturnType<typeof dismissSetupAnnouncement>>, TError, void, TContext> => {
  const mutationKey = ['dismissSetupAnnouncement'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof dismissSetupAnnouncement>>, void> = () => {
    return dismissSetupAnnouncement(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DismissSetupAnnouncementMutationResult = NonNullable<Awaited<ReturnType<typeof dismissSetupAnnouncement>>>;

export type DismissSetupAnnouncementMutationError = ApiError;

/**
 * @summary Dismiss the soft setup announcement banner
 */
export const useDismissSetupAnnouncement = <TError = ApiError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<typeof dismissSetupAnnouncement>>, TError, void, TContext>;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof dismissSetupAnnouncement>>, TError, void, TContext> => {
  return useMutation(getDismissSetupAnnouncementMutationOptions(options), queryClient);
};
export const getDismissSetupPanelUrl = () => {
  return `/current-user/setup-panel/dismiss`;
};

/**
 * Sets profiles.setup_panel_dismissed_at to NOW() and clears profiles.setup_announcement_show_until in the same UPDATE. One-way — no resurrection. Idempotent: re-POSTing simply re-stamps the timestamps.
 * @summary Permanently dismiss the dashboard Setup panel
 */
export const dismissSetupPanel = async (options?: RequestInit): Promise<void> => {
  return apiFetcher<void>(getDismissSetupPanelUrl(), {
    ...options,
    method: 'POST',
  });
};

export const getDismissSetupPanelMutationOptions = <TError = ApiError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof dismissSetupPanel>>, TError, void, TContext>;
  request?: SecondParameter<typeof apiFetcher>;
}): UseMutationOptions<Awaited<ReturnType<typeof dismissSetupPanel>>, TError, void, TContext> => {
  const mutationKey = ['dismissSetupPanel'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof dismissSetupPanel>>, void> = () => {
    return dismissSetupPanel(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DismissSetupPanelMutationResult = NonNullable<Awaited<ReturnType<typeof dismissSetupPanel>>>;

export type DismissSetupPanelMutationError = ApiError;

/**
 * @summary Permanently dismiss the dashboard Setup panel
 */
export const useDismissSetupPanel = <TError = ApiError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<typeof dismissSetupPanel>>, TError, void, TContext>;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof dismissSetupPanel>>, TError, void, TContext> => {
  return useMutation(getDismissSetupPanelMutationOptions(options), queryClient);
};
export const getSetCurrentShopUrl = () => {
  return `/current-user/current-shop`;
};

/**
 * Switches the authenticated user to a different shop they have access to
 * @summary Set current shop
 */
export const setCurrentShop = async (setCurrentShopBody?: SetCurrentShopBody, options?: RequestInit): Promise<void> => {
  return apiFetcher<void>(getSetCurrentShopUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(setCurrentShopBody),
  });
};

export const getSetCurrentShopMutationOptions = <TError = ApiError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setCurrentShop>>,
    TError,
    { data?: SetCurrentShopBody },
    TContext
  >;
  request?: SecondParameter<typeof apiFetcher>;
}): UseMutationOptions<Awaited<ReturnType<typeof setCurrentShop>>, TError, { data?: SetCurrentShopBody }, TContext> => {
  const mutationKey = ['setCurrentShop'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof setCurrentShop>>, { data?: SetCurrentShopBody }> = (
    props
  ) => {
    const { data } = props ?? {};

    return setCurrentShop(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SetCurrentShopMutationResult = NonNullable<Awaited<ReturnType<typeof setCurrentShop>>>;
export type SetCurrentShopMutationBody = SetCurrentShopBody | undefined;
export type SetCurrentShopMutationError = ApiError;

/**
 * @summary Set current shop
 */
export const useSetCurrentShop = <TError = ApiError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof setCurrentShop>>,
      TError,
      { data?: SetCurrentShopBody },
      TContext
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof setCurrentShop>>, TError, { data?: SetCurrentShopBody }, TContext> => {
  return useMutation(getSetCurrentShopMutationOptions(options), queryClient);
};
